import { render, staticRenderFns } from "./SearchInputComponent.vue?vue&type=template&id=2fad55ca&"
import script from "./SearchInputComponent.vue?vue&type=script&lang=js&"
export * from "./SearchInputComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports